import CoreComponent from '../../core/CoreComponent.vue';
import LoadingDots from '@/dow-platform/components/commerce/shared/loading-dots/index.js';
import DcAlert from '../forms/DcAlert.vue';
export default {
  extends: CoreComponent,
  data() {
    return {
      showError: false,
      showInternalError: false,
      showDisabledError: false,
      hideRedirect: false,
      baseURL: window.ciamLoginURL
    };
  },
  components: {
    LoadingDots,
    DcAlert
  },
  methods: {
    loginClick() {
      this.$store.commit('loading/setLoading', true);
      let gotoUrl = "";
      if (window.location.search.indexOf('redirectUrl') > -1) {
        const urlParams = new URLSearchParams(window.location.search);
        const redirectValue = urlParams.get('redirectUrl');
        gotoUrl = encodeURIComponent(decodeURIComponent(redirectValue));
      }
      const servletUrl = new URL(window.location.origin + this.$store.state.settings.oidc_login_initiation_servlet);
      servletUrl.searchParams.set('goto', gotoUrl);
      window.location.href = servletUrl.toString();
    },
    getLabel(key) {
      return window.Granite.I18n.get(key);
    },
    getExternalLabel(key) {
      return window.Granite.I18n.get(key).replace("{0}", this.languageCode).replace("{1}", "support/general-inquiries-other.html");
    },
    async login(payload) {
      return await this.$store.dispatch('user/loginCIAMUser', payload).then(() => {
        if (this.reauthorizationRequired) {
          this.$store.commit('loading/setLoading', false);
          return;
        }
        this.$store.dispatch('user/loginRedirect').then(() => {});
      }).catch(error => {
        if (error.response.data.errorCode == 400) {
          this.showError = false;
          this.showInternalError = false;
          this.showDisabledError = false;
          this.hideRedirect = true;
          this.hideRightSide(false);
        } else if (error.response.data.errorCode == 401) {
          this.loginClick();
        } else if (error.response.data.errorCode == 404) {
          this.showInternalError = true;
          this.hideRedirect = true;
        } else if (error.response.data.errorCode == 403) {
          this.showDisabledError = true;
          this.hideRedirect = true;
        } else {
          this.showError = true;
          this.hideRedirect = true;
        }
        this.$store.commit('loading/setLoading', false);
      });
    },
    hideRightSide(isHide) {
      var loginInfoSection = document.getElementById("in-page-login-info");
      var loginContainerSection = document.getElementById("in-page-login-wrap");
      if (isHide) {
        if (loginInfoSection) {
          loginInfoSection.style.display = 'none';
        }
      } else {
        if (loginInfoSection) {
          loginInfoSection.style.display = 'block';
        }
      }
    }
  },
  mounted() {
    this.hideRightSide(true);
    this.$store.commit('loading/setLoading', true);
    this.$store.dispatch('user/updateDccUserInfo').then(() => {
      if (this.$store.state.user.isAuthenticated) {
        this.$store.commit('loading/setLoading', false);
        this.$store.dispatch('user/loginRedirect');
      } else if (!this.$store.state.user.isAuthenticated) {
        let authCode = null;
        let state = null;
        let redirectValue = window.location.origin + window.location.pathname;
        const url = new URL(redirectValue);
        if (window.location.search.indexOf('code') > -1) {
          const keepSearchParams = ['redirectUrl', 'fromRegistration', 'interest'];
          let currentUrl = new URL(window.location.href);
          keepSearchParams.forEach(param => {
            if (currentUrl.searchParams.has(param)) {
              url.searchParams.set(param, currentUrl.searchParams.get(param));
            }
          });
          const urlParams = new URLSearchParams(window.location.search);
          authCode = urlParams.get('code');
          state = urlParams.get('state');
          window.history.replaceState({}, document.title, url.toString());
        }
        let payload = {
          code: authCode,
          state: state
        };
        this.login(payload);
      } else {
        this.showError = true;
      }
    });
  },
  computed: {
    languageCode() {
      return this.$store.state.browser.languageCode;
    },
    reauthorizationRequired() {
      return this.$store.state?.user?.reauthorizationRequired;
    },
    loading() {
      return this.$store.state.user?.loading;
    },
    userLoggedOut() {
      return this.$store.state.user?.hasTimedOut;
    },
    dccUserInfo() {
      return this.$store.state.user?.dccUserInfo || {};
    }
  }
};